// crewbit-admin/src/pages/Money/Settings/Paid.tsx
//
// /money/settings/paid — Getting Paid sub-screen.

import { useEffect } from 'react';
import { PageHeader } from '../../../components/common/PageHeader';
import PaidPanel from '../../../components/money/settings/PaidPanel';
import { useActiveBusinessStore } from '../../../hooks/useActiveBusiness';
import { admin, spacing } from '../../../styles/tokens';

const pageStyle: React.CSSProperties = {
  padding: spacing.xl,
  background: admin.bg,
  minHeight: '100vh',
};

export function MoneySettingsPaid() {
  const businessId = useActiveBusinessStore((s) => s.activeBusinessId);

  useEffect(() => {
    document.title = 'CrewBit · Getting paid';
  }, []);

  return (
    <div style={pageStyle}>
      <PageHeader
        title="Getting paid"
        description="Stripe Connect, accepted methods, late-fee policy."
        back={{ to: '/money/settings', label: 'Money settings' }}
      />
      <PaidPanel businessId={businessId} />
    </div>
  );
}
